import { post } from '../helpers/FetchHelper'

const CreateFileS3 = async body => {
  try {
    const url = `${process.env.REACT_APP_API_UPLOAD_URL}createfile`
    return await post(url, body)
  } catch (e) {
    console.log({ error: e })
    return false
  }
}

export default CreateFileS3
